export * from './ingenique-api.interface';
